    <app-ai-preview
            [dialogState]="data"
            (triggerAction)="updateAction($event)"
    >
    </app-ai-preview>
